import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppWithSSO from './AppWithSSO';
import reportWebVitals from './reportWebVitals';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';

// Create MSAL instance for SSO
const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL and handle redirect promise for SSO callback
msalInstance.initialize().then(() => {
  console.log('MSAL initialized successfully');
  
  return msalInstance.handleRedirectPromise();
}).then((response) => {
  if (response?.account) {
    msalInstance.setActiveAccount(response.account);
  }
}).catch((error) => {
  console.error('MSAL initialization or redirect error:', error);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <AppWithSSO />
    </MsalProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
